export default __webpack_public_path__ + "static/media/Nintendo.8e0c10e4.svg";